import template from './info.html';
import {
  MOVE_DATE_MIN_ISO_8601,
  MOVE_DATE_MAX_ISO_8601,
} from '../../../constants';
import { actions, selectors } from '../../../state';
import './info.global.css';

export default class GetStartedInfoController {
  constructor(updStore, $element, $scope) {
    'ngInject';
    Object.assign(this, {
      updStore,
      $element,
      $scope,
      dates: {
        min: MOVE_DATE_MIN_ISO_8601,
        max: MOVE_DATE_MAX_ISO_8601,
      },
    });
  }

  $onInit() {
    const { connect, dispatch, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);

    // Not using `connect` here since we're attaching this to a form
    const state = getState();
    this.info = {
      first_name: selectors.signUp.userFirstName(state),
      last_name: selectors.signUp.userLastName(state),
      middle_name: selectors.signUp.userMiddleName(state),
      suffix_name: selectors.signUp.userSuffixName(state),
      cell_phone: selectors.signUp.userPhone(state),
      move_date: selectors.signUp.moveDate(state),
    };
  }

  $postLink() {
    this.$element[0]
      .querySelector('#moveDate')
      .addEventListener('input', e =>
        this.$scope.$apply(() => this.onDateChange(e.target.value))
      );
  }

  $onDestroy() {
    this.disconnect();
  }

  onDateChange(date) {
    this.info.move_date = date;
  }

  submit(data) {
    const { dispatch } = this.updStore;
    dispatch(actions.signUp.setInfo(data));
    dispatch(actions.router.stateGo(this.next));
    dispatch(actions.analytics.track(this.successEvent));
  }
}

export const GetStartedInfoComponent = {
  template,
  controller: GetStartedInfoController,
};

function mapStateToThis(state) {
  const siteConfig = selectors.current.siteConfig();
  let contact = siteConfig.divisionName(state) || siteConfig.companyName(state);

  if (
    !contact ||
    contact.length === 0 ||
    contact.toLowerCase() === 'updater' /*app.updater.com reports updater here*/
  ) {
    contact = 'those in charge of setting your move date';
  }

  return {
    next: selectors.router.currentDataProp('next', state),
    successEvent: selectors.router.currentAnalyticsProp('success', state),
    contact,
  };
}
